import React, { Component } from 'react'
import Store from 'app/stores/research/azf/dataManage'
import DataHeader from './containers/DataHeader'
import DataTable from './containers/DataTable'
import dataIcon from "app/styles/images/sp/data-selected.svg"
import "./Index.scss"

export default class Index extends Component {
  constructor(props) {
    super(props)
    this.store = Store.fromJS()
  }
  render() {
    return (
      <div className="datamanage-page research">
        <h2 className="page-title"><img alt="" src={dataIcon} />AZF类型编辑</h2>
        <div className="clearfix wrapper-box-first">
          <DataHeader store={this.store} />
        </div>
        <div>
          <DataTable store={this.store} />
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/app/pages/research/azf/data_manage/index.js